export default (tracker) => ({
  async sort(params) {
    await tracker.track('Filter results sorted', {
      sortedBy: params.sortedBy,
      numberOfOptions: params.numberOfOptions,
    })
  },

  async resultsLoaded(params) {
    await tracker.track('Filter results loaded', {
      totalResults: params.totalResults,
      totalPages: params.totalPages,
      pageNumber: params.pageNumber,
    })
  },

  async resultClicked(params) {
    await tracker.track('Filter result clicked', {
      resultElementClicked: params.resultElementClicked,
      numberInList: params.numberInList,
    })
  },

  async clearFilter(params) {
    await tracker.track('Clear filter', {
      filterText: params.filterText,
    })
  },

  async clearAllFilters() {
    await tracker.track('Clear all filters')
  },

  async changeViewType(viewType) {
    await tracker.track('Change view type', {
      viewType,
    })
  },
})
